import { useNavigate, useLocation } from "react-router-dom"
import { useEffect } from "react"

import { LoadingPage } from "src/components/loader"
import { apiClient } from "src/utils"

export default function Login() {
  const navigate = useNavigate()
  const location = useLocation()
  let returnTo = "/"

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)
    const code = queryParams.get("code")
    const state = queryParams.get("state")

    let addlParams = ""
    if (state !== null) {
      try {
        const stateObj = JSON.parse(decodeURIComponent(state))
        if (stateObj.returnTo && stateObj.returnTo.startsWith("/")) {
          returnTo = stateObj.returnTo || "/"
        }
      } catch (e) {}
      // adding tolt referral code so that it gets stored in the DB if new user
      addlParams = `&${state}`
    }

    apiClient
      .get(`/auth/login?code=${code}${addlParams}`)
      .then((response) => {
        if (response.access_token) {
          localStorage.setItem("token", response.access_token)
          navigate(returnTo)
        }
      })
      .catch(() => {
        navigate(returnTo)
      })
  }, [location, navigate])

  return <LoadingPage />
}
